import { Theme } from "@mui/material/styles";
import { neutral } from "app/themes/colors";

export const getTabsComponents = (sunoTheme: Theme) => ({
  MuiTabs: {
    styleOverrides: {
      root: {
        borderBottom: "1px solid #E0E0E0",
        "& .MuiTabs-indicator": {
          backgroundColor: "#C79AEB",
        },
      },
    },
  },
  MuiTabPanel: {
    styleOverrides: {
      root: {
        padding: 0,
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        color: neutral[900],
        fontSize: sunoTheme.typography.pxToRem(18),
        lineHeight: sunoTheme.typography.pxToRem(26),
        paddingTop: sunoTheme.spacing(1),
        paddingBottom: sunoTheme.spacing(1),
        paddingLeft: sunoTheme.spacing(2.5),
        paddingRight: sunoTheme.spacing(2.5),
        textTransform: "none",
        fontWeight: 400,
        "& .MuiTabs-indicator": {
          backgroundColor: neutral[600],
        },
        "&.Mui-selected": {
          color: "#090A0A",
          fontWeight: 700,
          letterSpacing: 0,
        },
      },
    },
  },
});
